import React, {useState, useEffect} from 'react';

import { useSelector,useDispatch } from "react-redux";
import { initializeApp } from '../../redux/reducers/appReducer';

import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {Preloader} from '../../components';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: '100%'
  },
  content: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    flexFlow: 'column nowrap'
  }
}));

const InitApp = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const { initialzed } = useSelector(state => state.appReducer);

    useEffect(() => {
        dispatch(initializeApp());   
    }, []);

    

  return (
    <div className={classes.root}>
   
      <main className={classes.content}>
          {/* <Preloader /> */}
          <CircularProgress color="inherit" />
        </main>
    </div>
  );
}


// InitApp.propTypes = {
//     className: PropTypes.string
//   };

export default InitApp;